import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";

import { useConversation } from "@lobees/chat-core";

import ConversationRightContactChatPanel from "./ConversationRightContactChatPanel";

const ComingSoonPanel = ({ label }) => (
  <Box
    sx={{
      flex: 1,
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      color: "text.secondary",
      gap: 1,
    }}
  >
    <ForumOutlinedIcon sx={{ fontSize: 48, opacity: 0.4 }} />
    <Typography variant="body1">{label}</Typography>
  </Box>
);

// First pass only implements the "contact" screen — group/task/ai chat in
// admin are a follow-up (Phase 3 continuation), same shared package, just
// more MUI presentational components to build.
const ConversationRightPanel = ({ isMobile = false }) => {
  const { screen } = useConversation();

  if (screen === "contact") {
    return <ConversationRightContactChatPanel isMobile={isMobile} />;
  }

  if (screen === "group") {
    return <ComingSoonPanel label="Group chat is coming soon to admin" />;
  }

  if (screen === "task") {
    return <ComingSoonPanel label="Task chat is coming soon to admin" />;
  }

  if (screen === "ai") {
    return <ComingSoonPanel label="AI assistant chat is coming soon to admin" />;
  }

  return <ComingSoonPanel label="Select a contact to start chatting" />;
};

export default ConversationRightPanel;
